import { insertScript } from '../../../../../../Common/Resources/src_front/js/helper-functions/insertScript';

export const pushengage = () => {
    window._peq = window._peq || [];
    window._peq.push(['init']);

    insertScript('https://clientcdn.pushengage.com/core/04fab9be-9bc6-4988-a156-bddf36176048.js');
};
